exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-77633768] .mint-field-core{text-align:center}", ""]);

// exports
